import styles from './index.module.scss';

export default function Index({ status = '404', desc = '服务器正在紧急搜索它的人脉 ...' }) {
  return (
    <div className={styles.layout}>
      <style jsx global>{`
        body,
        html {
          margin: 0;
          padding: 0;
        }

        body {
          background-color: #f4f5fa;
          height: 100%;
        }
      `}</style>
      <img className={styles.pic} src='https://i9.taou.com/maimai/p/34388/6428_6_412QLsOBNp3mPBdC' alt={status} />
      <div className={styles.status}>{status}</div>
      <div className={styles.desc}>{desc}</div>
    </div>
  );
}
